import React, { memo } from "react";
import { DKNSkeleton } from "../../../../components/ui";
import { Link } from "react-router-dom";
import { DKNEventIcon } from "../../../../components/ui/icons/DKNIcons";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { useCalendarEvents } from "../../../events/hooks/useEvents";
import "./RightBar.css";

// ---------------------------------------------------------------------------
// Widget: Upcoming Events (real API)
// ---------------------------------------------------------------------------
const EventsWidget = memo(function EventsWidget() {
  const { t } = useTranslation();
  const now = new Date();
  const { data, isLoading } = useCalendarEvents(
    now.getFullYear(),
    now.getMonth() + 1,
  );
  const allEvents = Array.isArray(data)
    ? data
    : (data?.events ?? data?.data ?? []);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const upcoming = allEvents
    .filter((ev) => {
      const d = new Date(ev.baS_TAR ?? "");
      return !isNaN(d) && d >= today;
    })
    .slice(0, 3);

  return (
    <div className="rightbar-widget">
      <div className="rightbar-widget-header">
        <DKNEventIcon className="rightbar-widget-icon" />
        <span className="rightbar-widget-title">
          {t("rightbar.upcomingEvents")}
        </span>
      </div>
      <div className="rightbar-widget-body">
        {isLoading
          ? [1, 2].map((i) => (
              <DKNSkeleton
                key={i}
                shape="text"
                style={{ width: "90%", height: 14, marginBottom: "0.25rem" }}
              />
            ))
          : upcoming.map((ev, idx) => {
              const dateStr = ev.baS_TAR ?? "";
              const d = new Date(dateStr);
              return (
                <div
                  key={ev.etkinliK_TARIH_ID ?? idx}
                  className="rightbar-event-item"
                >
                  <div className="rightbar-event-date">
                    <span className="rightbar-event-day">
                      {!isNaN(d) ? d.getDate() : ""}
                    </span>
                    <span className="rightbar-event-month">
                      {!isNaN(d) ? format(d, "MMM") : ""}
                    </span>
                  </div>
                  <span className="rightbar-event-title">
                    {ev.baslik ?? ""}
                  </span>
                </div>
              );
            })}
      </div>
      <Link to="/events" className="rightbar-see-all">
        {t("rightbar.seeAll")} →
      </Link>
    </div>
  );
});

const RightBar = memo(function RightBar() {
  return (
    <aside className="rightbar-container">
      <EventsWidget />
    </aside>
  );
});

export default RightBar;
